import { use, InitOptions } from 'i18next'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

export const defaultLanguage = 'en'
export const languages = ['en', 'de']

// https://www.i18next.com/overview/configuration-options
export const i18nextOptions = (appNS: string): InitOptions => ({
  fallbackLng: defaultLanguage,
  supportedLngs: languages,

  keySeparator: '.',
  nsSeparator: ':',
  // ns: ['ui', appNS],
  ns: [appNS],
  defaultNS: appNS,

  load: 'languageOnly',
  nonExplicitSupportedLngs: false,
  returnEmptyString: false,
  returnNull: false,

  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
  },

  parseMissingKeyHandler: (key: string) => {
    const splitKey = key.split('.')
    return splitKey[splitKey.length - 1]
  },

  react: {
    useSuspense: true,
    defaultTransParent: 'div',
    hashTransKey(defaultValue: string) {
      console.log('missing key', defaultValue)
      return defaultValue
    },
  },
})

export const i18nInitialize = (appNS: string) =>
  use(I18nextBrowserLanguageDetector).use(Backend).use(initReactI18next).init(i18nextOptions(appNS))
